import { useState } from "react";
import ActionBar from "../components/actionBar/ActionBar";
import LocationCard from "../components/locationCard/LocationCard";
import LocationModal from "../components/modals/locationModal/LocationModal";
import { useLocations } from "../hooks/useLocations";
import strings from "../i18n/i18nStrings";
import { TLocation } from "../types/Locations";

const LocationsPage = () => {
  const { locations, createLocation, updateLocationById, deleteLocation } = useLocations();

  const [currentlyEditingLocation, setCurrentlyEditingLocation] = useState<TLocation | undefined>(undefined)
  const [isLocationModalOpen, setIsLocationModalOpen] = useState(false);

  const onEditLocation = (id: string) => {
    const selectedLocation = locations.find(l => l._id === id)

    if (selectedLocation) {
      setCurrentlyEditingLocation(selectedLocation)
      setIsLocationModalOpen(true)
    }
  }

  const onAddLocation = () => {
    setCurrentlyEditingLocation(undefined)
    setIsLocationModalOpen(true)
  }

  return (
    <div className="flex p-0">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-6 mb-20">
        {/* <pre>Locations: {JSON.stringify(locations)}</pre> */}
        {locations &&
          locations.map((location: TLocation, index: number, ) => (
            <LocationCard
              key={location._id}
              location={location}
              index={index}
              onEditLocation={() => onEditLocation(location._id)}
            />
          ))}
      </div>
      <ActionBar>
        <div />
        <button
            className={`ml-auto px-4 py-3 border border-transparent rounded-md shadow-sm text-xs font-bold uppercase tracking-wider text-white ${
              "bg-blue-700 hover:bg-blue-800"
            }`}          onClick={onAddLocation}
        >
          {strings.locations.addLocation}
        </button>
      </ActionBar>
      {isLocationModalOpen && (
        <LocationModal
          createLocation={createLocation}
          onClose={() => setIsLocationModalOpen(false)}
          selectedLocation={currentlyEditingLocation}
          updateLocationById={updateLocationById}
          deleteLocation={deleteLocation}
        />
      )}
    </div>
  );
};

export default LocationsPage;
